import { FC } from 'react'

import { ISvgClass } from '../interface'

const EmailOutlineIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.56804 7L12 11.8089L19.432 7L4.56804 7ZM4 9.01462L4 17L20 17L20 9.01461L12.5433 13.8396L12 14.1911L11.4567 13.8396L4 9.01462ZM2 6C2 5.44772 2.44772 5 3 5L21 5C21.5523 5 22 5.44772 22 6L22 18C22 18.5523 21.5523 19 21 19L3 19C2.44772 19 2 18.5523 2 18L2 6Z"
        fill="inherit"
      />
    </svg>
  )
}

export default EmailOutlineIcon
